


































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Issue } from '@/interfaces/Issue';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import { Environment } from '@/interfaces/Environment';
import { Changelog } from '@/interfaces/Changelog';

@Component({})
export default class ChangelogCard extends Vue {
  @Prop()
  cutoverplan!: Cutoverplan;

  @Prop()
  changelog!: Changelog;

  datemenu = false;

  get backgroundColor() {
    const environment = this.$store.state.all_environments.find(
      (e: Environment) => e.id === this.changelog.environment_id
    );
    if (environment) return environment.color;
    return '#FFFFFF';
  }

  get environments() {
    return [
      {
        value: null,
        text: 'ALLE'
      },
      ...this.$store.state.all_environments.map((environment: any) => ({
        value: environment.id,
        text: environment.name
      }))
    ];
  }
}
